import { render, staticRenderFns } from "./ButtonValidate.vue?vue&type=template&id=601c6e79&scoped=true&"
import script from "./ButtonValidate.vue?vue&type=script&lang=js&"
export * from "./ButtonValidate.vue?vue&type=script&lang=js&"
import style0 from "./ButtonValidate.vue?vue&type=style&index=0&id=601c6e79&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601c6e79",
  null
  
)

component.options.__file = "ButtonValidate.vue"
export default component.exports